/**
 * Dynamically loads Shiprocket script and calls notifyShiprocketCheckout
 * Prevents duplicate script loading by checking for existing script ID
 */
function loadShiprocketScript(callback) {
  const scriptId = 'shiprocket-events-script';
  const scriptUrl = 'https://fastrr-boost-ui.pickrr.com/assets/js/channels/events.js';
  
  // Check if script already exists
  if (document.getElementById(scriptId)) {
    console.log('Shiprocket script already loaded');
    if (callback && typeof callback === 'function') {
      callback();
    }
    return;
  }
  
  // Create and configure script element
  const script = document.createElement('script');
  script.id = scriptId;
  script.src = scriptUrl;
  script.type = 'text/javascript';
  script.async = true;
  
  // Handle successful load
  script.onload = function() {
    console.log('Shiprocket script loaded successfully');
    if (callback && typeof callback === 'function') {
      callback();
    }
  };
  
  // Handle load error
  script.onerror = function() {
    console.error('Failed to load Shiprocket script');
  };
  
  // Append script to document head
  document.head.appendChild(script);
}

/**
 * Calls the notifyShiprocketCheckout function with login event
 * @param {string} token - Authentication token
 */
function triggerShiprocketLogin(token) {
  if (typeof notifyShiprocketCheckout === 'function') {
    notifyShiprocketCheckout({
      eventName: "S2S_LOGIN",
      payload: {
        token: token
      }
    });
    console.log('Shiprocket login event triggered');
  } else {
    console.error('function not available');
  }
}

/**
 * Main function to load script and trigger login
 * @param {string} token - Authentication token
 */
function initShiprocketLogin(token) {
  loadShiprocketScript(function() {
    // Small delay to ensure function is available
    setTimeout(function() {
      triggerShiprocketLogin(token);
    }, 100);
  });
}

// Export for use in other files
window.ZopShiprocket = {
  init: initShiprocketLogin,
  loadScript: loadShiprocketScript,
  triggerLogin: triggerShiprocketLogin
};